import React from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'underscore';
import { getDetailInpatientClaimBySysAdmin, getClaimOptions, getBankOptions, editInpatientClaimBySysAdmin } from '../../../actions'
import { Button, Grid, Divider, Segment, Header, Input, Message } from 'semantic-ui-react';
import { Formik, Form, Field, FieldArray } from 'formik';
import moment from 'moment';
import FormsInputsText from '../../../component/forms/inputs/text/forms_inputs_text';
import FormsInputDropdown from '../../../component/forms/inputs/dropdown/index';
import BankUtility from "../../../utils/bankUtility/BankUtility";
import { USER_ROLES, USER_TYPE, CLAIM_STATUS } from "../../../constants";
import CommonUtility from "../../../utils/CommonUtility";

const paymentMethodOptions = [
    // { text: 'Cheque', value: 'Cheque' },
    { text: 'Bank', value: 'Bank' }
];

const FLAG_BRANCH_NOT_SELECTED = "BRANCH_NOT_SELECTED"

const prepareBankListOptions = (list) => {
    return _.map(list, (item, index) => {
        return { text: item.n, value: item.n, key: index };
    });
}

const prepareBranchListOptions = (list, bankName) => {

    if (Array.isArray(list) && bankName) {
        for (var i = 0; i < list.length; i++) {
            if (list[i].n.toLowerCase() === bankName.toLowerCase()) {
                let branchList = _.map(list[i].branches, (item, index) => {
                    return { text: item.n, value: item.c, key: index };
                });
                branchList.unshift({ text: "-- Please Select Branch --", value: FLAG_BRANCH_NOT_SELECTED })
                return branchList;
            }
        }
    } else {
        return [{ text: "-- Please Select Bank --", value: FLAG_BRANCH_NOT_SELECTED }];
    }
}

const getBankNo = (list, bankName) => {
    //alert(number, list);
    for (var i = 0; i < list.length; i++) {
        if (list[i].n.toLowerCase() === bankName.toLowerCase()) {
            return list[i].c;
        }
    }
}

const getBankName = (list, bankNo) => {
    for (var i = 0; i < list.length; i++) {
        if (list[i].c === bankNo) {
            return list[i].n;
        }
    }
}

class InpatientViewImbursement extends React.Component {

    bankUtility = new BankUtility();

    state = {
        successSubmit: undefined,
        errorMsg: ''
    }

    onProposedBankNoChange(evt, formikData) {

        const bankNo = ("" + formikData.field.value).replace(/\D+/g, '')
        const bankName = getBankName(formikData.bankList, bankNo);
        const accountNo = formikData.values.proposedBankDetail.accountNo;

        formikData.setFieldValue("proposedBankDetail.bankName", bankName);
        formikData.setFieldValue("proposedBankDetail.bankNo", bankNo);

        // auto select branch
        this.selectProposedBankBranch(bankName, accountNo, formikData);
    }

    onProposedBankNameChange(evt, formikData) {
        const bankName = formikData.field.value;
        const bankNo = getBankNo(formikData.bankList, bankName)
        const accountNo = formikData.values.proposedBankDetail.accountNo;

        formikData.setFieldValue("proposedBankDetail.bankName", bankName);
        formikData.setFieldValue("proposedBankDetail.bankNo", bankNo);

        // auto select branch
        this.selectProposedBankBranch(bankName, accountNo, formikData);
    }

    onProposedBankAccountChange(evt, formikData) {
        try {
            let bankName = formikData.values.proposedBankDetail.bankName;
            let accountNo = evt.target.name === "proposedBankDetail.accountNo" ? evt.target.value : formikData.values.proposedBankDetail.accountNo;

            // validate number
            accountNo = accountNo.replace(/\D+/g, '');

            // set the filtered value to responsible variable
            if (evt.target.name === "proposedBankDetail.accountNo") {
                formikData.setFieldValue("proposedBankDetail.accountNo", accountNo);
            }

            // auto select branch
            this.selectProposedBankBranch(bankName, accountNo, formikData);

        } catch (err) {
            // console.error(err);
        }
    }

    onBranchNoChange(evt, formikData) {
        const branchNo = ("" + formikData.field.value).replace(/\D+/g, '');

        if (branchNo === FLAG_BRANCH_NOT_SELECTED) {
            formikData.setFieldValue("proposedBankDetail.branchNo", "");
            formikData.setFieldValue("proposedBankDetail.branchName", FLAG_BRANCH_NOT_SELECTED);
        } else {
            formikData.setFieldValue("proposedBankDetail.branchNo", branchNo);
            formikData.setFieldValue("proposedBankDetail.branchName", branchNo);
        }
    }

    selectProposedBankBranch(bankName, accountNo, formikData) {
        try {
            const bankNo = getBankNo(formikData.bankList, bankName);
            const branchCode = this.bankUtility.getBranchCode(bankNo, accountNo);
            const bankInUI = formikData.bankList.find(bank => bank.c === bankNo);
            const branchInUI = bankInUI.branches.find(branch => branch.c === branchCode);

            // General validation for account no digit
            this.bankUtility.isValidAccountNoDigit(bankNo, accountNo);

            // Populate UI
            // Handle Bank of China
            if (bankNo === "7083") {
                formikData.setFieldValue("proposedBankDetail.branchNo", "011");
                formikData.setFieldValue("proposedBankDetail.branchName", "011");
                formikData.setFieldValue("proposedBankDetail.accountNo", this.bankUtility.getAccountNo(bankNo, accountNo) || accountNo);
            }
            else if (branchCode && branchInUI) {

                if (["7339", "7232", "9548", "7991"].includes(bankNo)) {
                    alert("Please note that the first 3 digits of the Account No is dropped and used as the Branch Code");
                }

                formikData.setFieldValue("proposedBankDetail.branchNo", branchCode);
                formikData.setFieldValue("proposedBankDetail.branchName", branchCode);
                formikData.setFieldValue("proposedBankDetail.accountNo", this.bankUtility.getAccountNo(bankNo, accountNo) || accountNo);
            } else {
                throw new Error("Branch not found");
            }
        } catch (err) {
            formikData.setFieldValue("proposedBankDetail.branchNo", "");
            formikData.setFieldValue("proposedBankDetail.branchName", FLAG_BRANCH_NOT_SELECTED);
        }
    }

    componentDidMount() {
        this.getClaimData();
    }

    getClaimData(){
        if (this.props.user.accessToken) {

            // Get user ID
            const queryString = new URLSearchParams(this.props.history.location.search);
            const _id = queryString.get("_id");

            // Get Inpatient Detail
            this.props.getDetailInpatientClaimBySysAdmin(this.props.user.accessToken, { _id });

            // Get bank list
            if (this.props.appConfig.bankList && !this.props.appConfig.bankList.blV2) {
                this.props.getBankOptions();
            }
        }
    }

    renderSubmitResult() {
        if (this.state.successSubmit === true) {
            return (
                <Message positive>
                    <Message.Header>Data Updated Successfully!</Message.Header>
                </Message>
            );
        }
        if (this.state.successSubmit === false) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue</Message.Header>
                    <p>{this.state.errorMsg}</p>
                </Message>
            );
        }
    }

    editClaim(values, actions) {
        try {
            this.setState({ ...this.state, successSubmit: undefined, errorMsg: '' });
            let accessToken = this.props.user.accessToken;

            let dataToSend = {
                _id: values._id,
                proposedBankDetail: values.proposedBankDetail
            }

            this.props.editInpatientClaimBySysAdmin(accessToken, dataToSend,
                (success, error) => {
                    actions.setSubmitting(false);
                    if (success) {
                        this.setState({ ...this.state, successSubmit: true, errorMsg: '' });
                        this.getClaimData();
                    }
                    if (error) {
                        this.setState({ ...this.state, successSubmit: false, errorMsg: error.errorMessage });
                    }
                }
            );
        } catch (err) {
            console.error(err);
        }
    }

    render() {

        const claimData = this.props.claims.detailInpatientData;
        const loading = this.props.claims.detailInpatientLoading && (!this.props.appConfig.bankList.blV2);
        let allowEdit = false;

        if (loading) return "Loading";
        if (!claimData) return "Data Not Found";
        if (claimData) {
            let isAdminOperation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.user) && CommonUtility.haveRoles([USER_ROLES.ADMIN_OPERATION], this.props.user);
            let isStatusProcessing = claimData.claimStatus === CLAIM_STATUS.PROCESSING ? true : false;
            allowEdit = isAdminOperation && isStatusProcessing;
        }
        return (

            <Formik
                initialValues={{
                    _id: claimData._id,
                    paymentMethod: claimData.paymentMethod,
                    bankNo: claimData.bankNo,
                    branchNo: claimData.branchNo,
                    accountNo: claimData.accountNo,
                    proposedBankDetail: {
                        bankName: claimData.proposedBankDetail ? claimData.proposedBankDetail.bankName : '',
                        bankNo: claimData.proposedBankDetail ? claimData.proposedBankDetail.bankNo : '',
                        branchNo: claimData.proposedBankDetail ? claimData.proposedBankDetail.branchNo : '',
                        branchName: claimData.proposedBankDetail ? claimData.proposedBankDetail.branchNo : '',
                        accountNo: claimData.proposedBankDetail ? claimData.proposedBankDetail.accountNo : '',
                        status: claimData.proposedBankDetail ? claimData.proposedBankDetail.status : '',
                    },
                }}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={this.editClaim.bind(this)}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => (
                        <Form>
                            <Segment>
                                <Grid container columns={2}>
                                    <Grid.Column width={16}>
                                        <Divider horizontal> <Header as="h3">Reimbursement Information</Header> </Divider>
                                    </Grid.Column>
                                    
                                    <Grid.Column width={16}>
                                        <Field name="paymentMethod" options={paymentMethodOptions} label="Payment to be made by" secondaryLabel="" component={FormsInputDropdown} disabled={true} />
                                    </Grid.Column>

                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <>
                                                <Grid.Column width={16}>
                                                    <Divider horizontal style={{ margin: "50px 0 0 0" }}> <Header as='h3'>Bank Data</Header></Divider>
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <Field name="bankNo" label="Bank Code" secondaryLabel="" component={FormsInputsText} disabled={true} />
                                                </Grid.Column>
                                                <Grid.Column>
                                                    <Field name="branchNo" label="Branch Code" secondaryLabel="" component={FormsInputsText} disabled={true} />
                                                </Grid.Column>
                                                <Grid.Column width={16}>
                                                    <Field name="accountNo" label="Bank Account Number" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                                </Grid.Column>

                                                {/* Render Proposed Bank */}
                                                <>
                                                    <Grid.Column width={16}>
                                                        <Divider horizontal style={{ margin: "50px 0 0 0" }}> <Header as='h3'>Proposed Bank Data</Header></Divider>
                                                    </Grid.Column>
                                                    <Grid.Column width={8}>
                                                        <Field
                                                            name="proposedBankDetail.bankNo"
                                                            label="Bank Code"
                                                            component={FormsInputsText}
                                                            secondaryLabel=""
                                                            disabled={!allowEdit}
                                                            onChange={(e, formikField) => { this.onProposedBankNoChange(e, { values, setFieldValue, bankList: this.props.appConfig.bankList.blV2, field: formikField }) }}
                                                        />
                                                    </Grid.Column>
                                                    <Grid.Column width={8}>
                                                        <Field
                                                            name="proposedBankDetail.bankName"
                                                            label="Bank Name"
                                                            component={FormsInputDropdown}
                                                            secondaryLabel=""
                                                            disabled={!allowEdit}
                                                            options={prepareBankListOptions(this.props.appConfig.bankList.blV2)}
                                                            onChange={(e, formikField) => { this.onProposedBankNameChange(e, { values, setFieldValue, bankList: this.props.appConfig.bankList.blV2, field: formikField }) }}
                                                        />
                                                    </Grid.Column>
                                                    <Grid.Column width={16}>
                                                        <Field
                                                            name="proposedBankDetail.accountNo"
                                                            label="Bank Account Number"
                                                            component={FormsInputsText}
                                                            secondaryLabel=""
                                                            disabled={!allowEdit}
                                                            onChange={(e, formikField) => { this.onProposedBankAccountChange(e, { values, setFieldValue, bankList: this.props.appConfig.bankList.blV2, field: formikField }) }}
                                                        />
                                                    </Grid.Column>
                                                    <Grid.Column width={8}>
                                                        <Field
                                                            name="proposedBankDetail.branchNo"
                                                            label="Branch Code"
                                                            component={FormsInputsText}
                                                            secondaryLabel=""
                                                            disabled={!allowEdit}
                                                            options={prepareBranchListOptions(this.props.appConfig.bankList.blV2, values.proposedBankDetail.bankName)}
                                                            onChange={(e, formikField) => { this.onBranchNoChange(e, { values, setFieldValue, bankList: this.props.appConfig.bankList.blV2, field: formikField }) }}
                                                        />
                                                    </Grid.Column>
                                                    <Grid.Column width={8}>
                                                        <Field
                                                            name="proposedBankDetail.branchName"
                                                            label="Branch Name"
                                                            component={FormsInputDropdown}
                                                            secondaryLabel=""
                                                            disabled={!allowEdit}
                                                            options={prepareBranchListOptions(this.props.appConfig.bankList.blV2, values.proposedBankDetail.bankName)}
                                                            onChange={(e, formikField) => { this.onBranchNoChange(e, { values, setFieldValue, bankList: this.props.appConfig.bankList.blV2, field: formikField }) }}
                                                        />
                                                    </Grid.Column>
                                                    {values.proposedBankDetail && values.proposedBankDetail.status &&
                                                        <Grid.Column>
                                                            <Field name="proposedBankDetail.status" label="Last Status" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                                        </Grid.Column>
                                                    }

                                                    {allowEdit &&
                                                        <>
                                                            <Grid.Column width={16}>
                                                                <Button loading={isSubmitting} type="submit" primary disabled={isSubmitting} fluid size="big">
                                                                    Update Proposed Bank Data
                                                                </Button>
                                                            </Grid.Column>

                                                        </>
                                                    }

                                                    <Grid.Column width={16}>
                                                        {this.renderSubmitResult()}
                                                    </Grid.Column>


                                                </>
                                            </>
                                        )
                                    }
                                </Grid>

                                <br />
                                <br />
                                <br />
                            </Segment>
                        </Form>
                    )}
            >

            </Formik>



        )

    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        claims: state.systemAdminClaims,
        claimOptions: state.claimOptions,
        appConfig: state.appConfig,
    };
}

export default connect(mapStateToProps, {
    getDetailInpatientClaimBySysAdmin,
    getClaimOptions,
    getBankOptions,
    editInpatientClaimBySysAdmin
})(withRouter(InpatientViewImbursement))